import React from 'react';
import {
    Typography,
} from '@material-ui/core';
import { sortBy } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { keyById } from '../../../../utils';
import { Select } from '../../../../ui-kit';
import { useWarehousesScope } from '../../providers/WarehouseScopeProvider';

const WarehouseSwitch = () => {
    const { t } = useTranslation();
    const { currentWarehouseId, switchWarehouse, warehouses } = useWarehousesScope();
    const [selectedId, setSelectedId] = React.useState(currentWarehouseId);
    const singleWarehouse = warehouses.length === 1;

    if(singleWarehouse){
        return <Typography>{warehouses[0].name}</Typography>;
    }

    const sortedWarehouses = sortBy(['name', 'asc'], warehouses);
    const keyedWarehouses = keyById(warehouses);


    const selectedWarehouse = keyedWarehouses[selectedId as string] ? keyedWarehouses[selectedId as string].name : '';

    const handleWarehouseSwitch = (warehouseId: string) => {
        if(warehouseId !== currentWarehouseId){
            setSelectedId(warehouseId);
            switchWarehouse(warehouseId);
        }
    };

    return (
        <Select
            label={t('Current warehouse')}
            dropdownPlacement="bottom-start"
            handleMenuItemClick={handleWarehouseSwitch}
            menuItems={sortedWarehouses}
            isDisabled={false}
            selectedId={currentWarehouseId}
            selectedName={selectedWarehouse}
        />
    );
};

export default WarehouseSwitch;
